var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2448 4.66699H9.53646H8.11979H1.74479C0.965625 4.66699 0.328125 5.30449 0.328125 6.08366V13.167C0.328125 13.9462 0.965625 14.5837 1.74479 14.5837H10.2448C11.024 14.5837 11.6615 13.9462 11.6615 13.167V6.08366C11.6615 5.30449 11.024 4.66699 10.2448 4.66699ZM10.2448 13.1669H1.74479V6.0836H10.2448V13.1669ZM7.41146 9.62516C7.41146 10.4043 6.77396 11.0418 5.99479 11.0418C5.21563 11.0418 4.57813 10.4043 4.57813 9.62516C4.57813 8.846 5.21563 8.2085 5.99479 8.2085C6.77396 8.2085 7.41146 8.846 7.41146 9.62516Z",
    fill: "#148235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11784 5.37533V3.95866C8.11784 2.00366 9.7045 0.416992 11.6595 0.416992C13.6145 0.416992 15.2012 2.00366 15.2012 3.95866C15.2012 3.95866 15.2012 4.3612 15.2012 4.66699C14.6167 4.66699 14.0042 4.66699 13.7845 4.66699V3.95866C13.7845 2.78283 12.8353 1.83366 11.6595 1.83366C10.4837 1.83366 9.5345 2.78283 9.5345 3.95866V5.37533H8.11784Z",
    fill: "#148235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock-open.d2a2da89b7cb1ad38c182e0a3c17ae53.svg";
export { ForwardRef as ReactComponent };